/**
 * Employee Web — `/me/my-attendance` route (EW-07).
 *
 * 2026-05-03 redesign: this is now the single-screen punch + history surface
 * matching `me-attendance.jsx` from the reference design bundle. The dedicated
 * `/me/punch` route is preserved only as a redirect for old deep-links.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { AttendanceLog } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/my-attendance")({
  staticData: { breadcrumb: { labelKey: "attendance:log.title" } },
  component: MyAttendanceTabRoute,
});

function MyAttendanceTabRoute(): JSX.Element {
  return <AttendanceLog />;
}
